import { Directive, Input } from "@angular/core";
import { NG_VALIDATORS, Validator, AbstractControl, ValidatorFn, FormGroup, ValidationErrors } from "@angular/forms";

export function passwordTheSaveValidator(password: any, reapeted: any): ValidatorFn {
    return (control: FormGroup):  ValidationErrors | null => {

        const firstControl = control.get(password);
        const secondControl = control.get(reapeted);

        return firstControl && secondControl && firstControl.value !== secondControl.value ? { 'notTheSame': true } : null;
    };
}


@Directive({
selector: '[passwordControlToCheck]',
providers: [{provide: NG_VALIDATORS, useExisting: NotTheSameValidatorDirective, multi: true}]
})
export class NotTheSameValidatorDirective implements Validator {
    @Input('passwordControlToCheck') passwordControlToCheck: string;
    @Input('secondValue') secondValue: string;

    validate(control: AbstractControl): ValidationErrors | null {
        return this.passwordControlToCheck ? passwordTheSaveValidator(this.passwordControlToCheck, this.secondValue)(control)
                                : null;
    }
}
